<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>日历海报</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.content" autocomplete="off" maxlength="30" placeholder="搜索内容"
							clearable @change="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-date-picker v-model="searchForm.date" type="date" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" size="small" placeholder="选择素材适用日期"
							@change="searchChange"></el-date-picker>
						</el-date-picker>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange" size="mini">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增日历海报</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="title" label="标题" align="center" />
			<el-table-column prop="content" label="内容" align="center">
				<template slot-scope="scope">
					<div v-html="scope.row.content"></div>
				</template>
			</el-table-column>
			<el-table-column prop="image_url" label="图片" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.image_url" :preview-src-list="[scope.row.image_url]" />
				</template>
			</el-table-column>
			<el-table-column prop="date" label="适用时间" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" align="center" />
			<el-table-column prop="update_time" label="更新时间" align="center" />
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" icon="el-icon-edit" type="primary"
						size="small">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" icon="el-icon-delete"
						type="danger" size="small">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="50%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="标题" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入标题" :rows="4" />
						</el-form-item>
						<el-form-item label="内容" prop="content">
							<el-input v-model="form.content" autocomplete="off" placeholder="请输入内容" :rows="4"
								type="textarea" />
						</el-form-item>
						<el-form-item label="适用时间" prop="date">
							<el-date-picker v-model="form.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
								type="date" align="right" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="图片" required>
							<el-image :src="form.image_url" style="width: 300px;height: 300px;"
								:preview-src-list="[form.image_url]" fit="contain" />
							<el-button type="info" @click="chooseImg">选择图片</el-button>
							<el-button type="info" @click="removeImg">删除图片</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>

		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -7vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
				<!-- <el-button @click="getout">取 消</el-button> -->
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>

	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getPosterDayList,
		addPosterDay,
		editPosterDay,
		deletePosterDay,
	} from "../../api/poster_day";

	import {
		getCookie
	} from "../../utils/util";

	import imgUpload from "../../components/uploadImg.vue";

	export default {
		mixins: [tableCommon],
		components: {
			imgUpload,
		},
		data() {
			return {
				titles: "",
				upImg: false,
				// statusDict: [],
				// 请求地址api
				api: {
					list: getPosterDayList,
					add: addPosterDay,
					edit: editPosterDay,
					del: deletePosterDay,
				},
				// 规则验证
				rules: {
					title: [{
						required: true,
						message: "请输入海报标题",
						trigger: "blur"
					}, ],
					content: [{
						required: true,
						message: "请输入海报内容",
						trigger: "blur"
					}, ],
					image_url: [{
						required: true,
						message: "请选择海报图片",
						trigger: "blur"
					}, ],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
				},
				tableData: [],
				// 图片
				imageUrl: "",
			};
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
		},
		methods: {
			changeDate() {
				this.$forceUpdate()
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();

						this.imageUrl = this.$refs.imgUpload.faData.url;
						this.form.image_url = this.imageUrl;
					}
					this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg() {
				this.upImg = true;
			},
			removeImg() {
				this.imageUrl = '';
				this.form.content = '';
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				editPosterDay(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			// 重置
			reset() {
				this.form = {
					// material_type: undefined,
					date: undefined,
					content: undefined
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.count = 0;
				this.form = JSON.parse(JSON.stringify(row));
				this.imageUrl = this.form.image_url;

				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				console.log('保存：', this.form)
				try {
					// 提交表单
					this.submitForm(this.form);
					this.conTypeFiles = [];
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>

<style scoped>
	.alright {
		color: #409eff;
		font-size: 32px;
		transform: translate(1%, 22%);
	}

	/deep/ .arcWrite .el-dialog__body {
		height: 65vh;
		overflow-y: auto;
		overflow: hidden;
	}

	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/information/poster_day.vue